var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconUserPlus({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#fff",
    strokeWidth: 2.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 8,
    r: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 21c0-3.9 3.1-7 7-7s7 3.1 7 7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 8v6M16 11h6"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUserPlus);
export default __webpack_public_path__ + "static/media/icon_user_plus.02f8632d1362f55999073ccfa131d1f8.svg";
export { ForwardRef as ReactComponent };